import { HttpParams } from '@angular/common/http';
import { Component, HostListener, Input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Sort_Utils } from 'src/app/entities/Sort_Utils';
import { UTILS } from 'src/app/entities/Utils';
import { Address, RubricaTable } from 'src/app/entities/various';
import { ConfigurationService } from 'src/app/services/configuration/configuration.service';
import { LoginService, UserInfo } from 'src/app/services/login/login.service';
import { ToastService } from 'src/app/services/toast/toast.service';

@Component({
  selector: 'app-rubrica',
  templateUrl: './rubrica.component.html',
  styleUrls: ['./rubrica.component.css']
})
export class RubricaComponent implements OnInit {

  innerWidth: number | undefined;
  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.innerWidth = window.innerWidth;
  }

  params : HttpParams;
  sortUtils : Sort_Utils = new Sort_Utils();
  pages = [{key : 2},{key : 12}, {key : 25}, {key : 50}, {key : 100}];
  addressesTable : RubricaTable | undefined;
  me : UserInfo | undefined;
  @Input() userId : number | undefined;

  editing : boolean = false;
  editingId : string | number | undefined;

  indirizzo: Address | undefined;



  constructor(private loginService: LoginService, private translate: TranslateService, private confService : ConfigurationService, private toastr: ToastService) {
    this.params = new HttpParams();
    this.params =this.params.append('endRow', 0);
    this.params =this.params.append('lastKeyVal', '');
    this.params =this.params.append('page', 1);
    this.params =this.params.append('pageDirection', 'FORWARD');
    this.params =this.params.append('pageSize', 12);
    this.params =this.params.append('pagination', true);
    this.params =this.params.append('paginationMode', 'SKIP');
    this.params =this.params.append('rows', 0);
    this.params =this.params.append('searchFilter', '{}');
    this.params =this.params.append('sortDir', 'ASC');
    this.params =this.params.append('sortKey', 'denominazione');
    this.params =this.params.append('startRow', 0);
    this.params =this.params.append('totalPages', -1);
    this.params =this.params.append('totalRows', 0);
    this.innerWidth = window.innerWidth;

   }
  async ngOnInit(): Promise<void> {
    this.me = JSON.parse(localStorage.getItem("einvuser") || "");
    this.addressesTable = await (await this.confService.getAddresses(this.userId!, this.params)).data;
  }

  async search(val : string) {
    this.params= this.params.delete('searchFilter');
    this.params= this.params.append('searchFilter', '{\"denominazione\":\"' + val +'\"}');
    this.addressesTable = await (await this.confService.getAddresses(this.userId!, this.params)).data;
  }

  async sort(key: string){
    this.params =this.params.delete('sortKey');
    this.params =this.params.delete('sortDir');
    this.params =this.params.append('sortKey', key);
    this.params =this.params.append('sortDir', this.sortUtils.getSortDir(key));
    await this.getTable();
  }


  async setPage(newPage:number){
    if(this.params.get('page') != null){
      this.params = this.params.set('page', newPage);
      await this.getTable();
    }
  }
  async prev(){
    if(this.params.get('page') != null){
      let val : number = +this.params.get('page')! - 1;
      this.params = this.params.set('page', val);
      await this.getTable();
    }
  }

  async next(){
    if(this.params.get('page') != null){
      let val : number = +this.params.get('page')! + 1;
      this.params = this.params.set('page', val);
      await this.getTable();
    }
  }

  async getTable(){
    let response = await this.confService.getAddresses(this.userId!, this.params);
    if(response.success){
      this.addressesTable = response.data;
      
    }
  }

  async esportaRubrica() {
    this.params = this.params.delete('pageSize');
    this.params = this.params.append('pageSize', 1000);
    let response = await this.confService.getAddresses(this.userId!, this.params);
    if(response.success){
      let jsonres = JSON.stringify(response.data.data);
      new UTILS().downloadFile('text/csv', btoa(jsonres), "rubrica.einv");
    }
  }

  async importaRubrica(event: any) {
    this.indirizzo = await (await this.confService.getNewAddress()).data;
    let file = (event.target.files[0]);
    let text = await file.text();
    let rubricajson = JSON.parse(text);
    rubricajson.forEach(async (element: any) => {
      if (this.indirizzo) {
        this.indirizzo.denominazione = element.denominazione;
        this.indirizzo.partita_iva = element.partita_iva;
        this.indirizzo.codice_fiscale = element.codice_fiscale;
        this.indirizzo.codice_ipa = element.codice_ipa;
        this.indirizzo.email_pec = element.email_pec;
        this.indirizzo.tipo = element.tipo;
        this.indirizzo.proprio_indirizzo = element.proprio_indirizzo;
        this.indirizzo.data = JSON.parse(element.json_data);
        
        let response = await this.confService.salvaIndirizzo(this.userId!, this.indirizzo!);
        //console.log(response);
        if (response && response.success) {
          this.toastr.openToastWithConfig(true, 5000, await new UTILS().getTranslateTitle(this.translate,"toast.save.success"), "success")
        } else {
          this.toastr.openToast(response.msg, "warning")
          
        }
        
      }
      
    });
  }

  async changePageSize (pageSize: number) {
    this.params= this.params.delete('pageSize');
    this.params= this.params.append('pageSize', pageSize);
    this.addressesTable = await (await this.confService.getAddresses(this.userId!, this.params)).data;
  }

  openEditor(id: string | number) {
    this.editing = true;
    this.editingId = id;
  }

}


